/**
 * What the server is currently serving to devices.
 *
 * Used by the Update confirmation so it can say which build a device has and
 * which one it is about to get.
 */
import api from './api';

export interface CurrentBuild {
    available: boolean;
    // Null on a zip published before build ids existed.
    version?: string | null;
    build?: string | null;
    uploadedAt?: string | null;
    fileSize?: number;
}

export const softwareApi = {
    /**
     * Returns null rather than throwing when the server cannot say.
     *
     * This only decorates a confirmation dialog, and an update must still be
     * possible when it fails - refusing to let somebody update a fleet because
     * a label could not be fetched would be the wrong trade.
     */
    getCurrentBuild: async (): Promise<CurrentBuild | null> => {
        try {
            const response = await api.get('/SoftwareDistribution/current-build');
            return response.data;
        } catch {
            return null;
        }
    },
};
